import type { SnapshotId } from '@ipfabric/utils';

import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { changeSnapshot } from 'pages/SnapshotManagement/actions';
import { useDispatch } from 'react-redux';

export interface ChangeSnapshotCommand {
  snapshotId: SnapshotId;
}

export const useChangeSnapshot = (): ((
  command: ChangeSnapshotCommand,
) => void) => {
  const dispatch = useDispatch();

  const changeSnapshotFunction = useStableCallback(
    (command: ChangeSnapshotCommand) => {
      dispatch(changeSnapshot(command.snapshotId));
    },
  );

  return changeSnapshotFunction;
};
